import { MailOutlineOutlined, Person } from '@mui/icons-material'
import { Dialog, InputAdornment, Slide, TextField } from '@mui/material'
import { Box } from '@mui/system'
import { useEffect, useState } from 'react'
import { usePricingMailMutation } from '../../helpers/SendEmailApi'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { CheckCircleIcon, XCircleIcon } from '@heroicons/react/24/solid'


function Transition(props) {
    return <Slide direction="up" {...props} timeout={600} />;
}

const CustomComponent = () => {
    return (
        <div className='h-full'>
            <div className='absolute top-0  left-0 right-0 z-[9999]'>
                <div className='flex justify-center'>
                    <CheckCircleIcon className='h-[55px] text-green-500 z-50 relative' />
                </div>
            </div>
            <div className='pt-[50px]'>
                <h1 className='text-center'>
                    Your response has been submitted successfully!
                </h1>
            </div>
        </div>
    )
}

const DialogBox = ({ open, setOpen, title, img, ans1, ans2 }) => {

    const [name, setname] = useState('')
    const [email, setemail] = useState('')

    const [func, res] = usePricingMailMutation()

    const handleSubmit = (e) => {
        e.preventDefault()
        func({ name, email, title, ans1, ans2 })
    }

    useEffect(() => {

        if (res.status === 'fulfilled') {
            setOpen(false)
            setname('')
            setemail('')
            toast(<CustomComponent />, {
                position: "top-center",
                autoClose: 1000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
                toastClassName: "rounded-lg",
                className: 'text-[18px] md:w-[400px] h-full mt-4 mx-4 rounded-md relative z-50',
                style: { borderRadius: '15px' },
            });
        }

    }, [res])


    return (
        <div>
            <div className='relative'>
                <ToastContainer />
            </div>
            <Dialog
                open={open}
                onClose={() => setOpen(false)}
                aria-labelledby="responsive-dialog-title"
                disableScrollLock={true}
                TransitionComponent={Transition}
                PaperProps={{
                    sx: {
                        width: { xs: '100%', sm: '500px' },
                        borderRadius: '20px',
                    }
                }}

            >
                <div className='p-3 bg-gradient-to-b from-red-500 to-red-400' >

                    <Box display={'flex'} justifyContent='flex-end' >

                        <XCircleIcon className='h-[40px] cursor-pointer hover:rotate-animation text-white' onClick={() => setOpen(false)} />
                    </Box>

                    <div className='flex flex-col items-center mt-2 max-w-[500px]'>
                        <img src={img} alt='img' className='h-[40px]' />
                        <h1 className='text-white font-bold mt-3 text-sm'>{title}</h1>
                        <p className='text-center text-white text-xs max-w-[400px]'>
                            Fill in the details below and we'll zone in your project in no time!
                        </p>
                    </div>

                    <Box component={'form'} onSubmit={(e) => handleSubmit(e)} width='90%' margin='0 auto'>
                        <Box display='flex' flexDirection={'column'} gap='20px' margin='10px 0' marginTop='30px'>
                            <TextField
                                placeholder='Enter Your Name'
                                id='Email'
                                required
                                value={name}
                                fullWidth
                                onChange={(e) => setname(e.target.value)}
                                InputProps={{
                                    disableUnderline: true,
                                    style: {
                                        fontSize: 15,
                                    },
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <Person sx={{ fontSize: '25px' }} />
                                        </InputAdornment>
                                    )
                                }}
                                sx={{

                                    '& .MuiInputBase-root': {
                                        padding: '7px 10px',
                                        borderRadius: '10px',
                                        transition: 'all 0.4s ease-in-out',
                                        backgroundColor: '#f5f5f5',
                                    },
                                    '& .Mui-focused': {
                                        backgroundColor: 'black !important',
                                        color: 'white',
                                        '& .MuiSvgIcon-root': {
                                            color: 'white'
                                        },
                                        '& ::placeholder': {
                                            color: 'white',
                                            opacity: '0.7'
                                        }
                                    },

                                }}
                                variant="standard"
                            />
                            <TextField
                                placeholder='Enter Your Email'
                                id='Email'
                                type={'email'}
                                required
                                fullWidth
                                value={email}
                                onChange={(e) => setemail(e.target.value)}
                                InputProps={{
                                    disableUnderline: true,
                                    style: {
                                        fontSize: 15,
                                    },
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <MailOutlineOutlined sx={{ fontSize: '25px' }} />
                                        </InputAdornment>
                                    )
                                }}
                                sx={{

                                    '& .MuiInputBase-root': {
                                        padding: '7px 10px',
                                        borderRadius: '10px',
                                        transition: 'all 0.4s ease-in-out',
                                        backgroundColor: '#f5f5f5',
                                    },
                                    '& .Mui-focused': {
                                        backgroundColor: 'black !important',
                                        color: 'white',
                                        '& .MuiSvgIcon-root': {
                                            color: 'white'
                                        },
                                        '& ::placeholder': {
                                            color: 'white',
                                            opacity: '0.7'
                                        }
                                    },

                                }}
                                variant="standard"
                            />

                        </Box>
                        <div className='my-4'>
                            <div className='my-4'>
                                <button
                                    className={`bg-yellow-400 w-full px-4   text-center ${res.isLoading ? 'py-[5px]' : 'py-[10px]'} rounded-2xl text-xs font-semibold hover:bg-yellow-500 duration-700`}>

                                    {res.isLoading ? (
                                        <div className='loading-dots flex gap-1 justify-center'>
                                            <span className='dots-cotainer'>
                                                <h1 className=' text-[6px] font-semibold text-black'>
                                                    CZ
                                                </h1>
                                            </span>
                                            <span className='dots-cotainer'>
                                                <h1 className=' text-[6px] font-semibold text-black'>
                                                    CZ
                                                </h1>
                                            </span>
                                            <span className='dots-cotainer'>
                                                <h1 className=' text-[6px] font-semibold text-black'>
                                                    CZ
                                                </h1>
                                            </span>

                                        </div>
                                    ) : 'Submit'}

                                </button>
                            </div>
                        </div>
                    </Box>
                </div>

            </Dialog>

        </div>
    )
}

export default DialogBox